





















































































import { Vue, Component, Prop, Watch } from "@/shared/vuepack";
import BannerForm from "@/admin/components/partners/BannerForm.vue";
import { BannerType, BannerSettingsViewMode } from "@/admin/types";
import type { PartnerBanner } from "@/shared/types";
import SwitchBannerTypeConfirmationModal from "@/admin/components/partners/SwitchBannerTypeConfirmationModal.vue";
import CustomBanners from "@/admin/components/partners/CustomBanners.vue";
import DefaultBanners from "@/admin/components/partners/DefaultBanners.vue";
import { useUserStore } from "@/shared/store/user";
import { useNotifierStore } from "@/shared/store/notifier";
import { useBannerStore } from "@/shared/store/banner";

@Component({ components: {DefaultBanners, CustomBanners, SwitchBannerTypeConfirmationModal, BannerForm } })
export default class BannerSettings extends Vue {
  @Prop() partnerId: string;
  activeTab: BannerType = "default";
  viewMode: BannerSettingsViewMode = "existing";
  selectedBanner = null;
  hasCustomBanner = false;

  private formRefreshCounter = 0;

  userStore = useUserStore();
  notifierStore = useNotifierStore();
  bannerStore = useBannerStore();
  isLoaded = true;
  switchModel: boolean = this.displayDefaultBanners;

  pendingPreference: boolean | null = null;

  showSwitchBannerTypeConfirmationModal = false;

  get displayDefaultBanners () {
    return this.bannerStore.displayDefaultBanners;
  }

  setActiveTab (tab: BannerType) {
    this.activeTab = tab;
  }

  setSwitchModel () {
    this.setActiveTab(this.displayDefaultBanners ? "default" : "custom");
    this.switchModel = this.displayDefaultBanners;
  }

  @Watch("partnerId")
  onPartnerIdChange () {
    this.loadDisplayDefaultBanners();
  }

   @Watch("bannerStore.customBanners")
  onCustomBannerChange () {
    this.hasCustomBanner = this.bannerStore.customBanners.length > 0;
  }

  onSwitchChange (newVal: boolean) {
    this.pendingPreference = newVal;
    this.showSwitchBannerTypeConfirmationModal = true;
  }

  confirmPreference (preference: boolean) {
    const payload = {isDisplayingDefaultBanners: preference};
     this.bannerStore.updateDisplayDefaultBanners(Number(this.partnerId), payload).then(() => {
       this.setSwitchModel();
       this.pendingPreference = null;
       this.showSwitchBannerTypeConfirmationModal = false;
     });
  }

  hidePreferenceModal () {
    this.setSwitchModel();
    this.pendingPreference = null;
    this.showSwitchBannerTypeConfirmationModal = false;
  }

  mounted () {
    this.loadDisplayDefaultBanners();
  }

  loadDisplayDefaultBanners () {
    this.bannerStore.getDisplayDefaultBanners(Number(this.partnerId)).then(() => {
      this.setSwitchModel();
    });
  }

  get bannerFormKey () {
    const idOrNew = (this.selectedBanner && this.selectedBanner.id) || "new";
    return `${idOrNew}-${this.formRefreshCounter}`;
  }

  openBannerForm (banner?: PartnerBanner) {
    this.selectedBanner = banner || null;
    this.formRefreshCounter += 1;
    this.viewMode = "create";
  }

  handleBackToExisting () {
    this.viewMode = "existing";
  }
}
